query allBasketballTeams(
  $first: Int,
  $offset: Int,
  $filter: BasketballTeamFilter,
  ) {
  teams: allBasketballTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamMappings: basketballTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      name
      source
      teamId
    }
    totalCount
  }
}
